import {Component, OnInit} from '@angular/core';
import {ASecureForm} from '../../sdk/interface/form/ASecureForm';
import {AuthenticationService} from '../../sdk/service/authentication.service';
import {EnvironmentService} from '../../sdk/service/environment.service';
import {FeeProfileSummary, FeeSummary, WebBusinessService} from 'web-angular-client';
import {ToMajorPipe} from '../../sdk/pipe/to-major.pipe';
import {CurrencyPipe} from '@angular/common';
import {AlertService} from '../../sdk/service/alert.service';

@Component({
    selector: 'app-fees',
    templateUrl: './fees.component.html',
    styleUrls: ['./fees.component.scss'],
    standalone: false
})
export class FeesComponent extends ASecureForm implements OnInit
{
    feeSummary: FeeSummary;

    constructor(
        protected authenticationService: AuthenticationService,
        protected environmentService: EnvironmentService,
        protected webBusiness: WebBusinessService,
        private alertService: AlertService,
        private toMajorPipe: ToMajorPipe,
        private currencyPipe: CurrencyPipe)
    {
        super(authenticationService, environmentService);
    }

    get feeProfileSummaryKeys()
    {
        const feeProfileKeys = this.feeSummary ? Object.keys(this.feeSummary?.feeProfileSummary[0]) as (keyof FeeProfileSummary)[] : null;
        return feeProfileKeys ? feeProfileKeys.filter(key => key != 'name') : [];
    }

    ngOnInit(): void
    {
        this.loadFeeSummary();
    }

    getFeeHeading(key: (keyof FeeProfileSummary))
    {
        switch (key)
        {
            case 'signupFee':
                return 'Signup Fee';
            case 'subscriptionFee':
                return 'Subscription Fee';
            case 'settlementFee':
                return 'Settlement Fee';
            case 'minFeeCap':
                return 'Minimum Fee';
            case 'percentageFee':
                return 'Transaction Fee';
            default:
                return '';
        }
    }

    getFeeFromFeeProfileSummary(key: (keyof FeeProfileSummary), feeProfileSummary: FeeProfileSummary)
    {
        switch (key)
        {
            case 'signupFee':
            case 'subscriptionFee':
            case 'settlementFee':
            case 'minFeeCap':
            {
                const feeProfileFee = feeProfileSummary[key] ?? null;
                const formattedFeeProfileFee = feeProfileFee ? this.currencyPipe.transform(
                    this.toMajorPipe.transform(feeProfileFee), 'R ') : null;

                return formattedFeeProfileFee ?? '-';
            }
            case 'percentageFee':
                return feeProfileSummary.percentageFee ? feeProfileSummary.percentageFee + '%' : '-';
            default:
                return '';
        }
    }

    private loadFeeSummary()
    {
        this.webBusiness.getFeeSummary().subscribe({
            next: (feeSummary: FeeSummary) =>
            {
                this.feeSummary = feeSummary;
            },
            error: () =>
            {
                this.alertService.error(
                    'There is an issue loading the fee summary. Please contact support for assistance');
            }
        });
    }
}
